import hero_img from '../assets/img/hero_bg2.jpg';
import { FaGithub } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { useState } from 'react';
const Contact = () => {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('');
    const [content, setContent] = useState('');
    return (
        <section id="contact" className="paralax-mf footer-paralax bg-image sect-mt4 route" style={{ backgroundImage: `url(${hero_img})` }}>
            <div className="overlay-mf" style={{ backgroundColor: 'transparent' }}></div>
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="contact-mf">
                            <div id="contact" className="box-shadow-full">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="title-box-2">
                                            <h5 className="title-left">
                                                Mándame un Mensaje
                                            </h5>
                                        </div>
                                        <div>
                                            <form className="php-email-form" method='post' action='https://formspree.io/f/xrgnponj'>
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <div className="form-group">
                                                            <input type="text" name="name" className="form-control" id="name" placeholder="Tu Nombre" value={name} required onChange={(e) => setName(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <div className="form-group">
                                                            <input type="email" className="form-control" name="email" id="email" placeholder="Tu Email" value={email} required onChange={(e) => setEmail(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <textarea className="form-control" name="message" rows="5" placeholder="Mensaje" required value={content} onChange={(e) => setContent(e.target.value)}></textarea>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 text-center" style={{ marginTop: '10%' }}>
                                                        <button type="submit" className="button button-a button-big button-rouded">
                                                            {'Enviar Mensaje'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="title-box-2 pt-4 pt-md-0">
                                            <h5 className="title-left">
                                                Mis Redes sociales
                                            </h5>
                                        </div>
                                        <div className="more-info">
                                            <p className="lead">
                                                También puedes contactarme a través de cualquiera de las siguientes redes sociales.</p>
                                        </div>
                                        <div className="socials">
                                            <ul>
                                                <li><a href="https://github.com/MateuJP"><span className="ico-circle"><FaGithub /></span></a></li>
                                                <li><a href="https://www.youtube.com/channel/UCKFOnZEhDuqf97gpFjxvZXw"><span className="ico-circle"><FaYoutube /></span></a></li>
                                                <li><a href="https://www.linkedin.com/in/mateu-joan-perelló-a35a142b3/"><span className="ico-circle"><FaLinkedin /></span></a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}
export default Contact;